import { del, get, post, put } from 'lib/actionHelpers.js';

export const getPipelineById = (pipelineId, callback) => {
  return get(`/pipeline/${pipelineId}`, {
    action: 'GET_PIPELINE',
    callback,
  });
};

export const postPipelineLead = (data, callback) => {
  return put(`/pipeline-lead/create`, {
    data,
    action: 'POST_PIPELINE_LEAD',
    callback,
  });
};

export const putPipelineLead = (data, pipelineLeadId, callback = () => {}) => {
  return post(`/pipeline-lead/${pipelineLeadId}/update`, {
    data,
    action: 'PUT_PIPELINE_LEAD',
    callback,
  });
};

export const deletePipelineLead = (data = {}, callback = () => {}) => {
  return del(`/provider/${data.serviceProviderId}/pipeline-lead/${data.id}`, {
    data: {},
    action: 'DELETE_PIPELINE_LEAD',
    callback,
  });
};
